import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import AdminSidebar from "../shared";
import { MdModeEditOutline, MdDeleteForever, MdEmail } from "react-icons/md";
import { getNodeApiBase } from "../../../utils/apiBase";


const Assigner = () => {
  const { id_comite } = useParams();
  const [selectedItem, setSelectedItem] = useState("Comite");
  const [selectedEvaluateur, setSelectedEvaluateur] = useState("");
  const [selectedProjet, setSelectedProjet] = useState("");
  const [searchProjet, setSearchProjet] = useState("");
  const [evaluateurs, setEvaluateurs] = useState([]);
  const [projets, setProjets] = useState([]);
  const [assignations, setAssignations] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showProjetDropdown, setShowProjetDropdown] = useState(false);
  const [dropdownProjetLabel, setDropdownProjetLabel] = useState(
    "Sélectionner un projet"
  );
  const [titreComite, setTitreComite] = useState("");
  const [notifyLoadingId, setNotifyLoadingId] = useState(null);
  const apiBase = getNodeApiBase();

  useEffect(() => {
    if (id_comite) {
      fetch(`${apiBase}/api/comite/${id_comite}/evaluateurs`)
        .then((res) => res.json())
        .then((data) => {
          if (data.evaluateurs) setEvaluateurs(data.evaluateurs);
        });
      fetch(`${apiBase}/api/comite/${id_comite}/projets`)
        .then((res) => res.json())
        .then((data) => {
          if (data.projets) setProjets(data.projets);
          // Try to get titre_comite from the first project if available
          if (
            data.projets &&
            data.projets.length > 0 &&
            data.projets[0].titre_comite
          ) {
            setTitreComite(data.projets[0].titre_comite);
          }
        });
      // Fetch assignations from backend
      fetch(`${apiBase}/api/comite/${id_comite}/assignations`)
        .then((res) => res.json())
        .then((data) => {
          if (data.assignations) setAssignations(data.assignations);
        });
      // Fetch titre_comite directly if not present in projets
      fetch(`${apiBase}/api/comite/${id_comite}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.comite && data.comite.titre_comite)
            setTitreComite(data.comite.titre_comite);
        });
    }
  }, [apiBase, id_comite]);

  const getEvaluateurName = (id) => {
    const found = evaluateurs.find((e) => String(e.idevaluteur) === String(id));
    return found ? `${found.nom} ${found.prenom}` : id;
  };
  const getProjetName = (id) => {
    const found = projets.find((proj) => String(proj.idprojet) === String(id));
    return found ? found.titre_projet || found.titre : id;
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      idevaluteur: selectedEvaluateur,
      idprojet: selectedProjet,
      id_comite: id_comite,
      date_assignation: new Date().toISOString().slice(0, 10),
    };
    try {
      if (editId) {
        // Update existing assignation
        const res = await fetch(
          `${apiBase}/api/assignation_evaluation/${editId}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
        const data = await res.json();
        if (data.success) {
          setAssignations((prev) =>
            prev.map((a) =>
              a.id === editId
                ? {
                    ...a,
                    evaluateur: selectedEvaluateur,
                    projet: selectedProjet,
                    date: new Date().toLocaleDateString(),
                  }
                : a
            )
          );
          setEditId(null);
        } else {
          alert("Erreur lors de la modification : " + (data.message || ""));
        }
      } else {
        // Create new assignation
        const res = await fetch(
          `${apiBase}/api/assignation_evaluation`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
        const data = await res.json();
        if (data.success) {
          setAssignations([
            ...assignations,
            {
              id: data.id_assignation_evaluation || Date.now(),
              evaluateur: selectedEvaluateur,
              projet: selectedProjet,
              date: new Date().toLocaleDateString(),
            },
          ]);
        } else {
          alert("Erreur lors de l'enregistrement : " + (data.message || ""));
        }
      }
      setSelectedEvaluateur("");
      setSelectedProjet("");
      setDropdownProjetLabel("Sélectionner un projet"); // <-- Reset dropdown label
      setSearchProjet(""); // <-- Reset search bar
    } catch (err) {
      alert("Erreur lors de l'enregistrement.");
    }
  };

  const handleModifyAssignation = (id) => {
    // Find the assignation by id (works for both new and DB-loaded assignations)
    const assign = assignations.find(
      (a) => String(a.id) === String(id) || String(a.id_assignation_evaluation) === String(id)
    );
    if (assign) {
      setSelectedEvaluateur(assign.idevaluteur || assign.evaluateur);
      setSelectedProjet(assign.idprojet || assign.projet);
      setEditId(assign.id || assign.id_assignation_evaluation);
      // Optionally update dropdown label for project
      setDropdownProjetLabel(
        `${assign.idprojet || assign.projet} - ${getProjetName(assign.idprojet || assign.projet)}`
      );
    }
  };

  const tableHeaderStyle = {
    padding: "12px",
    borderBottom: "2px solid #ddd",
    fontWeight: "bold",
  };

  const tableCellStyle = {
    padding: "10px",
    borderBottom: "1px solid #ccc",
  };

  const actionButton = (color, disabled = false) => ({
    backgroundColor: color,
    color: "#fff",
    padding: "6px 12px",
    marginRight: "8px",
    border: "none",
    borderRadius: "4px",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
  });
  const handleSendNotification = async (assignation) => {
    const assignationId =
      assignation.id_assignation_evaluation || assignation.id;
    if (!assignationId) {
      alert("Impossible de retrouver l'assignation.");
      return;
    }
    try {
      setNotifyLoadingId(assignationId);
      const res = await fetch(
        `${apiBase}/api/assignation_evaluation/${assignationId}/notify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      );
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || "Envoi impossible.");
      }
      if (data.targetEmail) {
        console.log("Notification envoyée à :", data.targetEmail);
      }
      alert(
        data.message ||
          "Notification envoyée : l'évaluateur recevra un email."
      );
    } catch (error) {
      alert(error.message || "Erreur lors de l'envoi de la notification.");
    } finally {
      setNotifyLoadingId(null);
    }
  };

  // Helper to format date as DD/MM/YYYY
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("fr-FR");
  };

  // Filtered projets for dropdown based on searchProjet
  const filteredProjets = projets.filter(
    (project) =>
      (project.titre_projet || project.titre || "")
        .toLowerCase()
        .includes(searchProjet.toLowerCase()) ||
      String(project.idprojet).includes(searchProjet)
  );

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <AdminSidebar />

      {/* Form */}
      <div
        style={{
          marginLeft: '250px',
          width: 'calc(100vw - 250px)',
          padding: '40px',
          backgroundColor: '#e4d2d2',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "10px",
            maxWidth: '1100px',
            width: '100%',
            margin: '0 auto',
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              marginBottom: "30px",
              fontSize: "2rem",
              fontWeight: "bold",
            }}
          >
            Assigner Évaluateur
          </h2>
          {/* Display Titre Comité above the table */}
          <div
            style={{
              fontWeight: "bold",
              fontSize: "1.1rem",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            {projets.length > 0 && projets[0].titre_comite
              ? projets[0].titre_comite
              : ""}
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "20px" }}>
              <label>Évaluateur :</label>
              <select
                value={selectedEvaluateur}
                onChange={(e) => setSelectedEvaluateur(e.target.value)}
                className="form-control"
              >
                <option value="">Sélectionner un évaluateur</option>
                {evaluateurs.length === 0 ? (
                  <option disabled>Aucun évaluateur pour ce comité</option>
                ) : (
                  evaluateurs.map((e) => (
                    <option key={e.idevaluteur} value={e.idevaluteur}>
                      {e.nom} {e.prenom}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label>Projet :</label>
              <div style={{ position: "relative" }}>
                <div
                  className="form-control"
                  style={{ cursor: "pointer", minHeight: "38px" }}
                  onClick={() => setShowProjetDropdown((v) => !v)}
                  tabIndex={0}
                >
                  {selectedProjet
                    ? getProjetName(selectedProjet)
                    : dropdownProjetLabel}
                </div>
                {showProjetDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      zIndex: 10,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      maxHeight: "220px",
                      overflowY: "auto",
                      marginTop: "2px",
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Rechercher un projet..."
                      value={searchProjet}
                      autoFocus
                      onChange={(e) => setSearchProjet(e.target.value)}
                      style={{
                        marginBottom: "8px",
                        border: "none",
                        borderBottom: "1px solid #eee",
                        borderRadius: 0,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                    {filteredProjets.length === 0 ? (
                      <div style={{ padding: "8px", color: "#888" }}>
                        Aucun projet pour ce comité
                      </div>
                    ) : (
                      filteredProjets.map((project) => (
                        <div
                          key={project.idprojet}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            background:
                              String(selectedProjet) ===
                              String(project.idprojet)
                                ? "#e9ecef"
                                : "#fff",
                          }}
                          onClick={() => {
                            setSelectedProjet(project.idprojet);
                            setDropdownProjetLabel(
                              `${project.idprojet} - ${
                                project.titre_projet || project.titre
                              }`
                            );
                            setShowProjetDropdown(false);
                            setSearchProjet("");
                          }}
                        >
                          {project.idprojet} -{" "}
                          {project.titre_projet || project.titre}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              Enregistrer
            </button>
          </form>

          <div style={{ marginTop: "40px" }}>
            <h3
              style={{
                marginBottom: "20px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                fontSize: "1.3rem",
                color: "black",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Liste des Assignations
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: "#222",
                  textTransform: "capitalize",
                  letterSpacing: "0.5px",
                }}
              >
                {titreComite && `| Comité : ${titreComite}`}
              </span>
            </h3>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#007bff", color: "#fff" }}>
                  <th style={tableHeaderStyle}>N Projet</th>
                  <th style={tableHeaderStyle}>Titre Projet</th>
                  <th style={tableHeaderStyle}>Évaluateur</th>
                  <th style={tableHeaderStyle}>Date d'assignation</th>
                  <th style={tableHeaderStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {assignations.map((a) => {
                  const rowId = a.id || a.id_assignation_evaluation;
                  const isNotifying = notifyLoadingId === rowId;
                  return (
                    <tr key={rowId}>
                      <td style={tableCellStyle}>{a.idprojet || a.projet}</td>
                      <td style={tableCellStyle}>{getProjetName(a.idprojet || a.projet)}</td>
                      <td style={tableCellStyle}>{getEvaluateurName(a.idevaluteur || a.evaluateur)}</td>
                      <td style={tableCellStyle}>{formatDate(a.date_assignation || a.date)}</td>
                      <td style={tableCellStyle}>
                        <button
                          style={actionButton("orange")}
                          onClick={() => handleModifyAssignation(rowId)}
                          title="Modifier"
                        >
                          <MdModeEditOutline size={10} />
                        </button>
                        <button
                          style={actionButton("#198754", isNotifying)}
                          onClick={() => handleSendNotification(a)}
                          disabled={isNotifying}
                          title="Notifier l'évaluateur"
                        >
                          {isNotifying ? "..." : <MdEmail size={10} />}
                        </button>
                        <button
                          style={actionButton("red")}
                          title="Supprimer"
                        >
                          <MdDeleteForever size={10} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assigner;
